import { PubSub, FormField } from '../../utils'

const LAYER_ID = 'register'

const FIELD_NAME = {
  PRODUCT_TYPE: 'Form.ProductType',
  CARD_PAYMENTS: 'Form.ProcessCardPayments'
}

let _pagePath = undefined
let _trackingData = {}

/**
 * Initializes the module
 */
const init = () => {
  if (window.dataLayer == undefined) return

  // If we're on a confirmation page, kill the session data and stop the script
  if (window.isConfirmationPage != undefined) {
    ['gtmengagements', 'gtmtrackingdata'].forEach(property => window.sessionStorage.removeItem(property))
    return
  }

  // collect the last item in the url path to later send to GTM
  const pageNameRegex = /\/[\w\-]+\/?$/gi

  _pagePath = window.location.pathname.match(pageNameRegex)[0].replace(/\//g, '')
  _trackingData = storedProp('gtmtrackingdata')

  setInitialState()
  addEventListeners()
}


/**
 * Simple wrapper for getting and setting session storage items
 * @param {String} prop the name of the storage item to get/set
 * @returns {Object} 
 */
const storedProp = prop => {
  if (!prop) return console.error(`The value of 'prop' is not defined`)

  return {
    get: () => JSON.parse(window.sessionStorage.getItem(prop)),
    set: (value) => {
      window.sessionStorage.setItem(prop, JSON.stringify(value))
    }
  }
}


/**
 * Sets the initial state object which will provide the lifecycle of the module
*/
const setInitialState = () => {
  // Get any pre-selected values and provide them to the store
  const $productTypeCheck = document.querySelector(`input[name="${FIELD_NAME.PRODUCT_TYPE}"]:checked`)
  const $clientTypeCheck = document.querySelector(`input[name="${FIELD_NAME.CARD_PAYMENTS}"]:checked`)

  let productTypeValue = undefined
  let clientTypeValue = undefined

  if ($productTypeCheck != null) productTypeValue = $productTypeCheck.value
  if ($clientTypeCheck != null) clientTypeValue = $clientTypeCheck.value

  if (_trackingData.get() == null) {
    _trackingData.set({
      hasRegisteredChangePosition: false,
      hasSwitchedJourney: false,
      isProductTypeSet: false,
      isCustomerTypeSet: false,
      isNtc: /false/i.test(clientTypeValue),
      isSwitcher: /true/i.test(clientTypeValue),
      isCardMachine: /cardmachine/i.test(productTypeValue),
      isPaymentGateway: /paymentgateway/i.test(productTypeValue)
    })
  }
}


/**
 * Set stored state object on change
 * @param {Object} e - event data
 */
const onFieldChange = e => {
  const $el = e.target
  const id = $el.id || $el.name
  const value = FormField($el).valueOf.radioGroup()
  const trackingData = _trackingData.get()

  if ($el.name == FIELD_NAME.PRODUCT_TYPE) {
    if (hasSetJourney()) trackingData.hasSwitchedJourney = true

    trackingData.isCardMachine = /cardmachine/i.test(value)
    trackingData.isPaymentGateway = /paymentgateway/i.test(value)
    trackingData.isProductTypeSet = true
  }

  if ($el.name == FIELD_NAME.CARD_PAYMENTS) {
    if (hasSetJourney()) trackingData.hasSwitchedJourney = true

    trackingData.isNtc = /false/i.test(value)
    trackingData.isSwitcher = /true/i.test(value)
    trackingData.isCustomerTypeSet = true
  }

  _trackingData.set(trackingData)
  sendEvent(engagement(id))
}


/**
 * Send current event data to GTM on click
 * @param {Object} e - Event data
 */
const onClick = e => {
  if (!e || !e.target || !e.target.dataset.trackingName) return
  sendEvent(engagement(e.target.dataset.trackingName))
}


/**
 * Send current event data to GTM on custom dropdown value change
 * @param {Object} e - Custom event data
 */
const onCustomDropdownChange = e => {
  if (!e || !e.target) return
  sendEvent(engagement(e.target.dataset.optionName))
}


/**
 * Given an Array of booleans returns binary string 
 * @param {Array} booleans - collection of booleans
 * @returns binary string
 */
const booleansToBinary = (booleans = []) => booleans.map(bool => Number(bool)).join('')


/**
 * Given an element ID will generate an engagement ID in the format required by marketing
 * @param {String} elementId - the given identifier of an interactive HTML element
 * @returns {Object} - engagement data
 */
const engagement = elementId => {

  const { isNtc, isSwitcher, isCardMachine, isPaymentGateway, hasSwitchedJourney } = _trackingData.get()

  // Convert assertions to binary for small base64 encoded ID
  const binaryJourneyType = booleansToBinary([isNtc, isSwitcher, isCardMachine, isPaymentGateway])

  const registeredEngagments = storedProp('gtmengagements')
  const engagmentCollection = registeredEngagments.get() != null ? registeredEngagments.get() : []

  const engagementId = `${LAYER_ID}.${booleansToBinary([hasSwitchedJourney])}.${window.btoa(_pagePath + binaryJourneyType + elementId)}`

  if (engagmentCollection.includes(engagementId) == false) {
    registeredEngagments.set([...engagmentCollection, engagementId])
  }

  return {
    id: engagementId,
    isRegistered: engagmentCollection.includes(engagementId)
  }
}


/**
 * Sends event data to GTM datalayer
 * @param {Object} engagement - engagement data
 */
const sendEvent = (engagement = { id: '', isRegistered: false }) => {
  const trackingData = _trackingData.get();

  if (trackingData.hasSwitchedJourney && trackingData.hasRegisteredChangePosition == false) {
    window.dataLayer.push({ event: 'registerFormTracking', changePosition: storedProp('gtmengagements').get().slice(-2)[0] })
    trackingData.hasRegisteredChangePosition = true
    _trackingData.set(trackingData)
  }

  if (engagement.isRegistered == false) {
    window.dataLayer.push({ event: 'registerFormTracking', formPosition: engagement.id })
  }
}

/**
 * Compare the status of both journey switcher elements
 * @returns {Boolean} - asserts wether the user has set their journey type
*/
const hasSetJourney = () => {
  const trackingData = _trackingData.get()

  return trackingData.isCustomerTypeSet && trackingData.isProductTypeSet
}

/**
 * Bind our event listeners
*/
const addEventListeners = () => {
  document.addEventListener('change', onFieldChange)
  document.addEventListener('click', onClick)
  PubSub.subscribe('customdropdown:change', onCustomDropdownChange)
}


const GtmTracking = { init }
export default GtmTracking



// WEBPACK FOOTER //
// ./js/self-serve/core/GtmTracking.js